module.exports = __webpack_public_path__ + "7917ed5c144825f7611e9d122989383d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-42.png
// module id = 126
// module chunks = 0